import { IconButton } from "ui/icon-button/icon-button";
import { type IconButtonProps } from "ui/button/button.types";

import Icons from "assets";

export type CloseButtonProps = Omit<IconButtonProps, "children" | "aria-label" | "variant"> & {
  "aria-label"?: string;
};

/** The 32x32 dismiss control: `Dialog`'s top-right corner, and the floating panels that close the same way. */
export const CloseButton = (props: CloseButtonProps) => {
  return (
    <IconButton
      variant="text"
      data-testid="modal-close-button"
      size="medium"
      color="inherit"
      {...props}
      aria-label={props["aria-label"] || "Close modal"}>
      <Icons.Close width={12} height={12} />
    </IconButton>
  );
};
